import React from "react";

const ArrowBidIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="8" viewBox="0 0 37 8" fill="none" {...rest}>
      <path d="M-0.000651121 3.68359C-0.000651121 5.15635 1.19326 6.35026 2.66602 6.35026C4.13877 6.35026 5.33268 5.15635 5.33268 3.68359C5.33268 2.21083 4.13877 1.01693 2.66602 1.01693C1.19326 1.01693 -0.000651121 2.21083 -0.000651121 3.68359ZM36.0196 4.03715C36.2148 3.84189 36.2148 3.5253 36.0196 3.33004L32.8376 0.14806C32.6423 -0.0472023 32.3257 -0.0472023 32.1305 0.14806C31.9352 0.343322 31.9352 0.659904 32.1305 0.855167L34.9589 3.68359L32.1305 6.51202C31.9352 6.70728 31.9352 7.02387 32.1305 7.21913C32.3257 7.41439 32.6423 7.41439 32.8376 7.21913L36.0196 4.03715ZM2.66602 3.68359V4.18359L35.666 4.18359V3.68359V3.18359L2.66602 3.18359V3.68359Z" fill="#6D7885"/>
    </svg>
  );
};

export default ArrowBidIcon;
